/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermitListAuthDisplay } from "cms/components/components/permit-list-auth/display";
import { PermitListAuthEditor } from "cms/components/components/permit-list-auth/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function PermitSelectComponent (props) {
    
    const { ...everything } = props;
    const displayText = "The user can select from available permit applications here.";
    const zoneProps = {
        ...everything,
        displayComponent: <PermitListAuthDisplay text={displayText} />,
        editComponent: <PermitListAuthEditor showCheckbox={false} />,
    };
    return getComponentZoneLayout(zoneProps);
}

PermitSelectComponent.displayName = "PermitSelectComponent";
export { PermitSelectComponent };
